import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
  progressBox: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

const Loader = ({
  children,
  isLoading,
  size = 100,
  isFixed = true
}: {
  children: any;
  isLoading: boolean;
  size?: number;
  isFixed?: boolean;
}) => {
  const classes = useStyles();
  return isLoading ? (
    <div
      className={classes.progressBox}
      style={isFixed ? {} : { position: 'relative' }}
    >
      <CircularProgress size={size} />
    </div>
  ) : (
    children
  );
};

export default Loader;
